import React from 'react'

import Layout from '../components/Layout'
import ProjetosList from '../components/sections/ProjetosList'
import PageHeader from '../components/sections/PageHeader'
import Contact from '../components/sections/Contact'

const Projetos = ({location}) => {
    return (
        <Layout location={location} seo={{title: 'Portfólio'}}>
            <PageHeader title={`Portfólio`} subTitle={`Um pouco de evolução :)`} size={`sm`}/>
            <ProjetosList />
            <Contact variant={`sm`} />
        </Layout>
    )
}

export default Projetos;